// components
import { AuthVectorContainerWrapper } from "./AuthVectorContainerWrapper"
import { AuthVectorHeader } from "./AuthVectorHeader"
import { AuthVectorImage } from "./AuthVectorImage"
import { AuthVectorSubHeading } from "./AuthVectorSubHeading"

export const AuthVectorContainer = () => (
    <AuthVectorContainerWrapper>
        <div className="xl:relative flex flex-col gap-10 lg:gap-8 xl:gap-0 flex-grow">
            <AuthVectorHeader />
            <AuthVectorImage />
        </div>
        <AuthVectorSubHeading />
    </AuthVectorContainerWrapper>
)
